import { Box, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";

const SurveyStatusPage = ({
  title,
  body,
  buttonText,
  buttonHref,
  color,
  icon,
}) => {
  const theme = useTheme();
  const titleColor = color ?? theme.palette.error.main;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh",
        textAlign: "center",
        px: 3,
      }}
    >
      {icon}
      <Typography
        variant="h2"
        sx={{ fontSize: "28px", fontWeight: "bold", color: titleColor, mb: 2 }}
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
        sx={{ fontSize: "18px", mb: 3, maxWidth: "600px", lineHeight: 1.6 }}
      >
        {body}
      </Typography>
      <Button
        disableRipple
        variant="contained"
        href={buttonHref}
        sx={{
          mt: 2,
          px: 4,
          py: 1.5,
          fontSize: "16px",
          fontWeight: "bold",
          borderRadius: "25px",
          textTransform: "none",
        }}
      >
        {buttonText}
      </Button>
    </Box>
  );
};

SurveyStatusPage.propTypes = {
  title: PropTypes.node.isRequired,
  body: PropTypes.node.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonHref: PropTypes.string.isRequired,
  color: PropTypes.string,
  icon: PropTypes.node,
};

export default SurveyStatusPage;
